import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "book-card h-100" }
const _hoisted_2 = { class: "book-card__title" }
const _hoisted_3 = {
  class: "book-card__pills",
  role: "list",
  "aria-label": "جزئیات کتاب"
}
const _hoisted_4 = {
  class: "book-card__pill book-card__pill--level",
  role: "listitem"
}
const _hoisted_5 = {
  class: "book-card__pill",
  role: "listitem"
}
const _hoisted_6 = { class: "book-card__desc" }
const _hoisted_7 = { class: "book-card__progress-row" }
const _hoisted_8 = ["id"]
const _hoisted_9 = ["aria-valuenow", "aria-labelledby"]
const _hoisted_10 = ["aria-label"]

import { computed } from "vue";
import BookCover from "@/components/BookCover.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BookCard',
  props: {
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  level: {
    type: String,
    required: true,
  },
  units: {
    type: String,
    required: true,
  },
  progress: {
    type: Number,
    required: true,
    validator: (value) => value >= 0 && value <= 100,
  },
  coverColor: {
    type: String,
    required: true,
    validator: (value) => ["blue", "purple"].includes(value),
  },
  coverTitle: {
    type: String,
    required: true,
  },
  logo: {
    type: String,
    required: true,
  },
  publisher: {
    type: String,
    required: true,
  },
},
  emits: ["continue"],
  setup(__props) {

const props = __props;



const progressLabel = computed(() => `${props.progress}% پیشرفت`);

const progressLabelId = computed(() =>
  `book-progress-${props.title.replace(/\s+/g, "-").toLowerCase()}`
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createVNode(BookCover, {
      color: __props.coverColor,
      title: __props.coverTitle,
      logo: __props.logo,
      publisher: __props.publisher
    }, null, 8, ["color", "title", "logo", "publisher"]),
    _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(__props.level), 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(__props.units), 1)
    ]),
    _createElementVNode("p", _hoisted_6, _toDisplayString(__props.description), 1),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("span", { id: progressLabelId.value }, _toDisplayString(progressLabel.value), 9, _hoisted_8)
    ]),
    _createElementVNode("div", {
      class: "book-card__progress-track",
      role: "progressbar",
      "aria-valuenow": __props.progress,
      "aria-valuemin": "0",
      "aria-valuemax": "100",
      "aria-labelledby": progressLabelId.value
    }, [
      _createElementVNode("div", {
        class: "book-card__progress-fill",
        style: _normalizeStyle({ width: `${__props.progress}%` })
      }, null, 4)
    ], 8, _hoisted_9),
    _createElementVNode("button", {
      type: "button",
      class: "book-card__continue-btn",
      "aria-label": `ادامه ${__props.title}`,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('continue')))
    }, " ادامه ← ", 8, _hoisted_10)
  ]))
}
}

})